angular.module('ResearchKitApplicationModule').factory('providerAccountService', ["$http", "$window", "$q", "$log", "$translate", "ceUrl", function ($http, $window, $q, $log, $translate, ceUrl) {
	var linkAccount = function (providerID, redirectPath, accountID, onErrorHandler, openNewWindow, windowWidth, windowHeight) {
		if (!redirectPath) {
			redirectPath = $window.location.pathname + $window.location.hash;
		}
		var rootUrl = ceUrl.getRoot();
		if (rootUrl && rootUrl.length > 0 && redirectPath.substring(0, rootUrl.length).toUpperCase() === rootUrl.toUpperCase()) {
			redirectPath = redirectPath.substring(rootUrl.length);
		}

		// DEV: Safari blocks popups in AJAX responses. Work-around is to open a blank window before the request and set the URL later
		var providerAuthWindow;
		if (openNewWindow) {
			var windowFeatures = null;
			if (windowWidth && windowHeight) {
				const w = windowWidth;
				const h = windowHeight;
				const y = $window.top.outerHeight / 2 + $window.top.screenY - (h / 2);
				const x = $window.top.outerWidth / 2 + $window.top.screenX - (w / 2);
				windowFeatures = "width=" + w + ",height=" + h + ",top=" + y + ",left=" + x;
			}
			providerAuthWindow = $window.open(ceUrl.make("home/loading"), 'providerauth', windowFeatures);
		}

		return $http.post(ceUrl.make("api/cfhrprovideraccounts/providerauthorizeurl"), {
			ProviderID: providerID,
			LoginState: {
				FinalRedirectPath: redirectPath,
				ExistingAccountID: accountID,
				SuppressErrorPage: openNewWindow
			},
			RedirectUriFallback: getRedirectTarget()
		}).then(function (response) {
			if (providerAuthWindow) {
				providerAuthWindow.location = response.data.AuthorizeUrlWithQuery;
			}
			else {
				$window.location = response.data.AuthorizeUrlWithQuery;
			}
		}, function (response) {
			if (providerAuthWindow) {
				providerAuthWindow.close();
			}
			var reason = 'Get provider authorize url failed';
			if (response.data && response.data.Message) {
				reason = response.data.Message;
			}
			$log.error(reason);
			$log.error(response);
			return $q.reject(reason);
		});
	};

	var connectExternalAccount = function (externalAccountProviderID, onErrorHandler, messageID, openNewWindow, windowWidth, windowHeight) {
		return new Promise(function (resolve, reject) {
			// DEV: setTimeout is a work-around for Firefox blocking new windows in message handlers
			$window.setTimeout(function () {
				linkAccount(externalAccountProviderID, getNotifyParentWindowRedirectTarget(openNewWindow && messageID), null, onErrorHandler, openNewWindow, windowWidth, windowHeight)
					.then(
						function () {
							resolve();
						},
						function (error) {
							reject(error);
						});
			}, 0);
		});
	};

	var getNotifyParentWindowRedirectTarget = function (messageID) {
		if (messageID) {
			return "cfhrprovideraccounts/complete?messageID=" + messageID +
				"&success=%SUCCESSVALUE%&errorMessage=%ERRORMESSAGE%";
		}
		return null;
	};

	var getRedirectTarget = function () {
		return $window.location.protocol + "//" + $window.location.host + ceUrl.make("cfhrprovideraccounts/redirecttarget");
	};

	var fetchData = function (accountID) {
		return $http.post(ceUrl.make("api/cfhrprovideraccounts/fetchaccountdata/" + accountID)).then(function (response) {
			return response.data;
		});
	};

	var removeAccount = function (accountID) {
		return $http.delete(ceUrl.make('api/cfhrprovideraccounts/account/' + accountID) + "?deleteData=true")
	};

	var promptForAccountRemoval = function (data, contentWindow, frameHostUrl) {
		$translate('delete-account-confirm-message', null, null, 'Do you really want to delete this account?')
			.then(function (deletionConfirmationPromptMessage) {
				if (confirm(deletionConfirmationPromptMessage)) {
					return handleDelete(data, contentWindow, frameHostUrl);
				} else {
					contentWindow.postMessage(
						{
							action: "DeleteProviderAccount",
							messageID: data.messageID,
							accountID: data.accountID,
							success: false
						}, frameHostUrl);
				}
			});
	};
	function handleDelete(data, contentWindow, frameHostUrl) {
		return $http.delete(ceUrl.make('api/cfhrprovideraccounts/account/' + data.accountID) + "?deleteData=true")
			.then(
				function () {
					contentWindow.postMessage(
						{
							action: "DeleteProviderAccount",
							success: true,
							messageID: data.messageID,
							accountID: data.accountID,
							baseUrl: $window.location.origin + ceUrl.getRoot()
						}, frameHostUrl);
				},
				function (response) {
					contentWindow.postMessage(
						{
							action: "DeleteProviderAccount",
							messageID: data.messageID,
							accountID: data.accountID,
							success: false,
							message: response.xhrStatus + " - " + response.statusText + " " + (response.data && response.data.Message ? " - " + response.data.Message : ""),
							baseUrl: $window.location.origin + ceUrl.getRoot()
						}, frameHostUrl);
				});
	}

	return {
		linkAccount: linkAccount,
		connectExternalAccount: connectExternalAccount,
		getRedirectTarget: getRedirectTarget,
		fetchData: fetchData,
		removeAccount: removeAccount,
		promptForAccountRemoval: promptForAccountRemoval
	};
}]);